import Logger from 'Logger'
import Backbone from 'backbone'
import _ from 'underscore'
import { API_ENDPOINT, API_PATH, getPointLoginUrl } from '../../config.js'
import { callbackHandler } from '../../manager/view.handler'
import { $number } from '../../utils'
import { eventBus } from '../../utils/eventBus'
import {
  buyPmangCash,
  giftPmangCash,
  submitAuto,
  submitGift,
  submitGoods,
  windowOpen,
} from './pay.view.handler'
import goodsCoutnerPartial from './template/partials/goodsCounter.mustache'
import goodsPackagePartial from './template/partials/goodsPackagePartial.mustache'
import payMethodPartial from './template/partials/payMethod.mustache'
import pwgPointPartial from './template/partials/pwgPoint.mustache'

// 템플릿
import pokerClassTpl from './template/class.mustache'
import giftTpl from './template/gift.mustache'
import normal from './template/normal.mustache'

/** 제휴 포인트 로그인 URL */
var pointLoginUrl = getPointLoginUrl()

export var PayView = Backbone.View.extend({
  template: {
    normal: normal,
    gift: giftTpl,
    pokerClass: pokerClassTpl,
  },

  initialize: function () {
    // this.model.off()
    this.model.on('change:isVisible', this.togglePopup, this)
    this.model.on('change:isSelectPmangCash', this.checkPayNowMethod, this)
    this.model.on('change', this.render, this)
    this.model.on('sync', this.render, this)

    /** 제휴 포인트 로그인후 post message를 받아 API에 로그인 요청 */
    const handlePointLogin = (event) => {
      if (event.origin !== pointLoginUrl) {
        Logger.info('Unknown event origin', event)
        return
      }

      if (
        event.data.action === 'milesoft:login' &&
        event.data.result === 'ok'
      ) {
        Logger.info('Login success:', event.data)
        var token = event.data.token

        fetch(API_ENDPOINT + API_PATH.CONNECT_POINT, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ token }),
        })
          .then((res) => {
            if (res.ok) {
              return res.json()
            } else {
              throw new Error('Failed to connect point')
            }
          })
          .then((result) => {
            Logger.info('Connect point result:', result)
            this.model.fetch() // 상품 정보 다시 불러오기
          })
      } else {
        Logger.info('Login failed:', event.data)
      }
    }

    window.addEventListener('message', handlePointLogin)
  },

  events: {
    // 결제방법 바로결제 메소드
    'click :not(.is-disabled--true)[data-select-pmangcash]':
      'selectPayPmangCash',
    'click :not(.is-disabled--true)[data-select-now]': 'selectPayNow',
    'click [data-select-method]': 'selectPayNowMethod',

    // 팝업 콜백
    'click [data-callback]': 'callbackHandler',

    // 상품 수량 조절
    'click [data-goods-counter]': 'goodsCountHandler',

    // 클래스 정책 체크
    'click .pmp-agrees>label': 'policyCheckHandler',

    // 구매창 트리거
    'click [data-pay-submit="class"]': 'submitAuto',
    'click [data-buy]': 'submitGoods',
    'click [data-gift]': 'submitGift',

    // 친구 ID 검증
    'click [data-validate-friend-id]': 'checkfriendId',
    'keyup [data-input-friend-id]': 'inputKeyup',

    // 제휴 포인트
    'click [data-point-handler="connectPoint"]': 'connectPoint',
    'click [data-point-handler="disconnectPoint"]': 'disconnectPoint',
    'click [data-point-handler="openPointDetail"]': 'openPointDetail',

    // VIP 쿠폰 선택
    'change [data-vip-coupons-select]': 'onVipCouponChange',
  },

  callbackHandler: callbackHandler,

  buyPmangCash: buyPmangCash,

  giftPmangCash: giftPmangCash,

  windowOpen: windowOpen,

  submitGoods: submitGoods,

  submitAuto: submitAuto,

  submitGift: submitGift,

  togglePopup: function () {
    if (this.model.get('isVisible')) {
      this.$el.show()
    } else {
      this.$el.empty().hide()
    }
  },

  selectPayPmangCash: function (event) {
    event.preventDefault()
    this.model.setPayPmangCash()
  },

  selectPayNow: function (event) {
    event.preventDefault()
    this.model.setPayNow()
  },

  selectPayNowMethod: function (event) {
    event.preventDefault()
    var payNowMethod = $(event.currentTarget).data('pay-now-method')
    this.model.setPayNowMethod(payNowMethod)
    Logger.info(payNowMethod)
  },

  checkPayNowMethod: function () {
    var currentMethod = this.model.get('payNowMethod')
    this.$el
      .find('[data-pay-now-method=' + currentMethod + ']')
      .addClass('is-checked--true')
  },

  policyCheckHandler: function (event) {
    event.preventDefault()
    this.model.checkPolicy()
  },

  // 상품 개수 변경
  goodsCountHandler: function (event) {
    event.preventDefault()
    var num = $(event.currentTarget).data('goods-counter')
    Logger.info('counter handler click', 'dec')
    this.model.goodsCounter(num)
  },

  // 인풋 키업
  inputKeyup: function (event) {
    this.debouncedFriendId()
    if (event.which == 13) {
      this.debouncedFriendId.cancel()
      $('[data-validate-friend-id]').trigger('click')
    }
  },

  // 키업 디바운스
  debouncedFriendId: _.debounce(function () {
    $('[data-validate-friend-id]').trigger('click')
  }, 1500),

  // 셀렉트 박스 - 선택후 GSN 확인 요청
  checkFriendGsn: function () {
    var __this = this
    var isFriendSearched = this.model.get('isFriendSearched')
    this.$el
      .find('.friend-list')
      .val(isFriendSearched ? null : this.model.get('friendGSN'))
      .select2({
        placeholder: '친구를 선택하세요',
        minimumResultsForSearch: Infinity,
        language: {
          noResults: function () {
            return '친구가 없습니다.'
          },
        },
      })
      .on('change', function (e) {
        Logger.info('change')
        var $target = $(e.currentTarget)
        __this.model.requestFriendGsnInfo(
          $target.val(),
          $target.select2('data')[0].text
        )
      })
      .on('select2:opening', function () {
        __this.debouncedFriendId.cancel()
      })
  },

  // 인풋창 - 아이디 작성시 ID 확인 요청 [엔터나 / 키업 2초후]
  checkfriendId: function (event) {
    event.preventDefault()

    var id = $(event.currentTarget).prev().val()

    if (id) {
      this.model.requestFriendIdInfo(id)
    } else {
      this.model.resetFriend()
    }
  },

  // 제휴 포인트 연결
  connectPoint: function (event) {
    event.preventDefault()
    window.open(
      `${pointLoginUrl}?loginOrigin=${encodeURIComponent(location.origin)}`,
      '_blank',
      'popup,width=500,height=700'
    )
  },

  openPointDetail: function (event) {
    event.preventDefault()
    var $model = this
    var popupModel = _.extend(
      {},
      {
        template: 'pointDetail',
        pwgPointUserBalance: $number(
          this.model.get('pwgPointUserBalance')
        ).comma(),
        pwgPointUserAccount: this.model.get('pwgPointUserAccount'),
        pwgPointUserUid: this.model.get('pwgPointUserUid'),
        onConfirm: function () {
          this.hide()
        },
        onDisconnect: function () {
          $model.disconnectPoint(event)
          this.hide()
        },
      }
    )
    eventBus.trigger('$popupShow', popupModel)
  },

  // 제휴 포인트 해제
  disconnectPoint: function (event) {
    event.preventDefault()

    fetch(API_ENDPOINT + API_PATH.DISCONNECT_POINT, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json()
        } else {
          throw new Error('Failed to disconnect point')
        }
      })
      .then((result) => {
        Logger.info('Disconnect point result:', result)
        this.model.fetch() // 상품 정보 다시 불러오기
      })
  },

  onVipCouponChange: function (event) {
    // vip_coupon_id
    const selectedValue = String(event.target.value)
    this.model.set({
      vipCouponSelectedId: selectedValue,
    })
  },

  render: function () {
    var data = this.model.toJSON()
    var template = this.template[data.template]
    var parsed = _.extend(data, {
      estimatedPoint: $number(data.estimatedPoint).comma(), // 구매시 받을 제휴 포인트
      goodsTotalRewardMoney: $number(data.goodsTotalRewardMoney).text({
        tag: true,
      }),
    })

    Logger.info('[Pay Render] Current model JSON:', parsed)

    var rendered = template.render(parsed, {
      goodsCoutnerPartial,
      payMethodPartial,
      goodsPackagePartial,
      pwgPointPartial,
    })

    this.$el.empty().append(rendered)
    this.checkPayNowMethod()

    if (data.template === 'gift') {
      this.checkFriendGsn()
    }

    return this
  },
})
